import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, filter } from "rxjs/operators";
import { SET_COURSE_STATUS_BEGIN, logError, setCourseStatusSuccess } from "../actions";
import { setCourseStatus } from "../utils/helpers";
export default function setCourseStatusEpic(action$, state$) {
    return action$.pipe(ofType(SET_COURSE_STATUS_BEGIN), filter(function() {
        return state$.value.completeable;
    }), map(function() {
        if (state$.value.api) {
            setCourseStatus(state$.value);
            return setCourseStatusSuccess();
        }
        return logError({
            error: new Error("No LMS API found"),
            key: "no_api"
        });
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "set_course_status"
        }));
    }));
}
